define(function(require) {
    // general
    const CN = require('civicsUtils/constants');
    const JSV = require('civicsUtils/JSV');
    // models
    const IpsModel = require('civicsBase/ipsModel');
    // collections
    const IpsModelCollection = require('civicsBase/ipsModelCollection');
    // date utilities (Moment.js replacement)
    const DateUtils = require('civicsUtils/date_utilities');

     var userLang = function(){
        var ret = navigator.language || navigator.userLanguage || 'en' ; 
        var gConfig = App.sessionStorage.get('CIVICS', 'GLOBAL_CONFIG');
        if(gConfig) {
            var json = JSON.parse(gConfig);
            if(json.cultureInfo){
                ret = json.cultureInfo;
            }
        }
        return ret;
    };

    // Initialize date utilities with user language function
    DateUtils.init(userLang);

    return {
        getUserLang: function() {
          return userLang();
        },
        getCaseInsensitive : function(obj, prop){
          prop = (prop + "").toLowerCase();
          for(var p in obj){
             if(obj.hasOwnProperty(p) && prop == (p+ "").toLowerCase()){
                   return obj[p];
                   break;
              }
           }
           return undefined;
        },
        setCaseInsensitive : function(obj, prop, val){
          prop = (prop + "").toLowerCase();
          for(var p in obj){
             if(obj.hasOwnProperty(p) && prop == (p+ "").toLowerCase()){
                   obj[p] = val;
                   break;
              }
           }
        },
        convertArrayToIpsCollection: function(array) {
            if (typeof array != 'array')
                return;
            var ipsCollection = new IpsModelCollection();
            array.forEach(
                function() {
                    ipsCollection.add(new IpsModel(item));
                }
            );
            return ipsCollection;
        },
        updateSyphon: function () {
          var self = this;
          Backbone.Syphon.KeySplitter = function(key) {
            if (key && key.trim() && key.length > 0) {
                return key.split(".");
            } else {
                return null;
            }
          };

          // Everything is valid by default
          Backbone.Syphon.InputReaders.registerDefault(function($el) {
            var dataType = $el.attr('data-dataType');
            var t = !_.isEmpty(dataType) ? dataType.toLowerCase() : dataType;
            var val = $el.val();
            if( val == "" ){
              if ( t && (t == 'system.decimal' || t == 'system.double' || t == 'system.int32' || t == 'system.int64' || t == 'system.int16' || t == 'system.single')){
                return 0;
              }
            }
            if ( t && (t == 'system.datetime')){
              val = self.dateTimeString(val,null);//zFixed
            }

            var field = $el.closest(".field");
            if ( field.length > 0){
              var fieldInputs = [];
              if ( $el.attr('name') && $el.attr('name').trim() != '' && $el.attr('type') != 'radio' ){
                fieldInputs = field.find('input[name="' + $el.attr('name').replace( /(:|\.|\[|\]|,|=|@)/g, "\\$1" ) + '"]');
              }
              // if there are more than 1 input with the same binds from the same field wrapper
              // Combine the text value
              if ( fieldInputs.length > 1 ){
                var finalVal = '';
                fieldInputs.each(function( index ) {
                  if ( index > 0 ){
                    finalVal = finalVal + ' '; // use space as a join character for now
                  }
                  finalVal = finalVal + $(this).val();
                });
                if ( t && (t == 'system.datetime')){
                  finalVal = self.dateTimeString(finalVal, null);//zFixed
                }

                return finalVal;
              }
            }

            if($el.hasClass("droppy-input")){
               val = self.civicsDropdownValue($el);
            }

            return val;
          });

          // Everything is valid by default
          Backbone.Syphon.KeyAssignmentValidators.registerDefault(function($el, key, value) {
            var valid = true;
            if ( $el.attr('specialType') && $el.attr('specialType').length>0 && $el.attr('specialType').trim().toLowerCase() =='grid'){
              valid = false;
            }
            return valid;
          });
        },
        parseDateString: function(dateString){
            return DateUtils.parseDateString(dateString);
        },
        dateExists: function(dateString) {
            if (typeof dateString == 'string' && dateString.indexOf(CN.DATE_TIME_MIN_VAL) < 0) {
                return true;
            }
            return false;
        },
		//we no longer use moment, so we return a date instead.
		createMoment: function(dateString){
			return DateUtils.parseDateString(dateString);
		},
        isISODate: function(dateString) {
          return dateString.includes('T');
        },
        civicsDateTimeString: function(date,time,removeOffset) {
          return DateUtils.civicsDateTimeString(date, time, removeOffset);
        },
        dateString: function(dateString){
            return DateUtils.dateString(dateString);
        },
        dateStringFromDate: function(date){
            return DateUtils.dateStringFromDate(date);
        },
        dateTimeString: function(dateString, timeString) {
            return DateUtils.buildISOStringFromDateAndTime(dateString, timeString);
        },
        //dateTimeString(dateString,timeString) above - Note that this does not need a time parameter to work - if the date string has a time, it will be used if the time parameter is empty.
        //timeString(dateString) below
        dateTimeStringFromDate: function(date){
            return DateUtils.buildISOStringFromDate(date);
        },
        timeString: function(dateString){
            return DateUtils.timeString(dateString);
        },
        parseDate: function(dateString) {
            // Expects dates in ISO 8601 format from the REST API such as ... "2016-07-15T00:00:00.0000000"
            if (!this.dateExists(dateString))
                return;

            var dt = dateString.split('T');

            if (!dateString || dateString.length == 0 || !dateString.match(/(\d+)/g))
                return;

            var parts = dateString.match(/(\d+)/g);
            if (!parts || parts.length < 4)
                return;

            return new Date(parts[0], parts[1] - 1, parts[2]);
        },
        removeTimeZone: function(dateString){
            return DateUtils.removeTimeZone(dateString);
        },
        civicsSetDropdownValue: function(element, value) {
            var droppylist = this.civicsGetDroppyList(element)
            // get the option that is to be selected
            var droppyopt = droppylist.find('.droppy-option[data-val="' + value + '"]');
            if ( droppyopt.length > 0) {
                // set all values to unselected, and select the new value in the dropdown
                droppylist.find('.droppy-option').attr("aria-selected", "false").removeClass("pre-selected active-opt");
                droppyopt.attr("aria-selected", "true").addClass("pre-selected active-opt");
                element.val(droppyopt.text()).attr("title", droppyopt.text());
            }
        },
        civicsSetDropdownbyName: function(element, name) {
            var droppylist = element.siblings(".droppy-list");
            // get the option that is to be selected

            var droppyopt = droppylist.find('.droppy-option').filter(function() {
                return $(this).text().toLowerCase() == name.toLowerCase();
            });

            if ( droppyopt.length > 0) {
                // set all values to unselected, and select the new value in the dropdown
                droppylist.find('.droppy-option').attr("aria-selected", "false").removeClass("pre-selected active-opt");
                droppyopt.attr("aria-selected", "true").addClass("pre-selected active-opt");
                element.val(droppyopt.text()).attr("title", droppyopt.text());
            }
        },
        civicsDropdownValue: function(element){
            if(element == null){
                return null;
            }

            var parentDiv = null;
            if ((element.is('.field') && element.children().hasClass('droppy')) //layer 1
            || element.hasClass('droppy')) { //layer 2
              parentDiv = element;
            } else if (element.hasClass('droppy-input')) { //or it could be the input itself.
              parentDiv = element.parent();
            } else {
              return null;
            }

            var selected = parentDiv.find('.droppy-list .droppy-option[aria-selected=true]');
            var val = null;
            //if a selection was found, use it regardless of the preselected value
            if(selected.length == 1){
                val = selected.attr('data-val');
            } else if(_.isEmpty(val)){
                //if we preselect a value, some times the aria-selected attribute is missing. If we don't have a selection, look for the preselection instead.
                val = parentDiv.find('.droppy-list .droppy-option.pre-selected').attr('data-val');
            }

            return val;

        },
        civicsDropdownText: function(element){
            if(element == null){
                return "";
            }

            var selected = element.parent().find('.droppy-list .droppy-option[aria-selected=true]');
            var text = null;
            //if a selection was found, use it regardless of the preselected value
            if(selected.length == 1){
                text = selected.text();
            } else if(_.isEmpty(text)){
                //if we preselect a value, some times the aria-selected attribute is missing. If we don't have a selection, look for the preselection instead.
                text = element.parent().find('.droppy-list .droppy-option.pre-selected').text();
            }

            return text;
        },
        civicsGetDroppyList: function($element) {
            let $list = $element.siblings(".droppy-list");

            //if we find it using siblings selector, return the list.
            if ($list.length === 1)
              return $list;

            //else find it to the detach dropdownLists container.
            var $ddlsContainer = $('body').find('#dropdownLists .rhy');
            if ($ddlsContainer.length === 1) {
              $list = $ddlsContainer.find('.'+$element.attr('id')+'-dropdown-container .droppy-list');
            }

          return $list;
        },
        civicsToastPop: function(text, type, time = 5000, element = '.rhythm-notifications') {
          $(element).first().rhyNotification({
            displaytime: time,
            template: '<div class="notification ' + type + '" aria-atomic="true" role="alert" aria-live="assertive"><span class="content"><span>' + text + '</span></span><button class="btn-icon browser-notification close-button" aria-label="' + i18n.t('CIVICS.COMMON.CLOSE_NOTIFICATION') + '"><svg class="icon floating-delete" focusable="false" aria-hidden="true"><title>' + i18n.t('CIVICS.COMMON.CLOSE') + '</title><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#floating-delete"></use></svg></button></div>'
          });
        },
        serializeDroppy: function(element){
          if(element == null){
            return {};
          }
          var data = {};

          $.each($(element).find('.droppy'), function(i,elt){
            var key = $(elt).find('.droppy-input').attr('name');
            var value = this.civicsDropdownValue($(elt));
            data[key] = value;
          }.bind(this));

          return data;
        },
        // clear a single select droppy
        clearDroppy: function(element) {
          if(element == null){
              return;
          }

          var parent = element.parent();


          parent.find('.droppy-option').removeClass('selected active-opt pre-selected');
          parent.find('.droppy-option:not(.multi-selected)').attr('aria-selected', false);

          element.val('');
          element.attr('title', '').attr('initval', '');
        },
        truncateString: {
          trimString: function (value, length) {
              if (value && value.length > length) {
                return value.substring(0, length) + '...';
            }
            return value;
          }
        },
        getApplicantType: function(instrumentType, applicantTypeIdOrCode) {
            if (typeof instrumentType != 'string') {
                return 'Invalid instrument type: must be string';
            }
            if (isNaN(applicantTypeIdOrCode) && typeof applicantTypeIdOrCode != 'string') {
                return 'Invalid applicantID or applicantCode: must be int or string';
            }
            if (applicantTypeIdOrCode == 0 || applicantTypeIdOrCode == '0') {
                return '';
            }

            var instType = instrumentType.toLowerCase();

            var appID, appCode;

            var applicantTypes = {
                building: [{
                    code: 'LicensedContact',
                    id: 2,
                    display: 'licensedContact'
                }, {
                    code: 'OtherContact',
                    id: 4,
                    display: 'otherContact'
                }, {
                    code: 'PropertyOwner',
                    id: 1,
                    display: 'propertyOwner'
                }],
                businesslicense: [{
                    code: 'LicensedContact',
                    id: 2,
                    display: 'licensedContact'
                }, {
                    code: 'OtherContact',
                    id: 1,
                    display: 'otherContact'
                }, {
                    code: 'PropertyOwner',
                    id: 3,
                    display: 'propertyOwner'
                }],
                codeenforcement: [{
                    code: 'LicensedContact',
                    id: 2,
                    display: 'licensedContact'
                }, {
                    code: 'OtherContact',
                    id: 4,
                    display: 'otherContact'
                }, {
                    code: 'PropertyOwner',
                    id: 1,
                    display: 'propertyOwner'
                }],
                planning: [{
                    code: 'LicensedContact',
                    id: 2,
                    display: 'licensedContact'
                }, {
                    code: 'OtherContact',
                    id: 4,
                    display: 'otherContact'
                }, {
                    code: 'PropertyOwner',
                    id: 1,
                    display: 'propertyOwner'
                }],
                project: [{
                    code: 'LicensedContact',
                    id: 2,
                    display: 'licensedContact'
                }, {
                    code: 'OtherContact',
                    id: 4,
                    display: 'otherContact'
                }, {
                    code: 'PropertyOwner',
                    id: 1,
                    display: 'propertyOwner'
                }],
                tradelicense: [{//new per amy
                    code: 'LicensedContact',
                    id: 2,
                    display: ''
                }, {
                    code: 'OtherContact',
                    id: 4,
                    display: ''
                }, {
                    code: 'PropertyOwner',
                    id: 1,
                    display: ''
                }],
                use: [{
                    code: 'LicensedContact',
                    id: 2,
                    display: 'licensedContact'
                }, {
                    code: 'OtherContact',
                    id: 4,
                    display: 'otherContact'
                }, {
                    code: 'PropertyOwner',
                    id: 1,
                    display: 'propertyOwner'
                }]
            };
            if (typeof applicantTypes[instType] == 'undefined') {
                return 'Unknown instrumentType: ' + instType;
            }
            var ret = '';
            if (!isNaN(applicantTypeIdOrCode) && typeof applicantTypeIdOrCode != 'string') {
                appID = applicantTypeIdOrCode;
                $.each(applicantTypes[instType], function(index, el) {
                    if (el.id == appID) {
                        ret = el.code; //we need to return code instead
                    }
                });
            } else if (typeof applicantTypeIdOrCode === 'string') {
                appCode = applicantTypeIdOrCode;
                $.each(applicantTypes[instType], function(index, el) {
                    if (el.code == appCode) {
                        ret = el.id; //need to return id instead
                        applicantTypeIdOrCode = ret;
                    }
                });
            }
            if(!_.isEmpty(ret) && typeof ret =='string'){  //need to return id of applicanttype
              return ret;
            }else {
              return applicantTypeIdOrCode;
            }
        },
        getApplicantTypeDescription: function (code, instType, types) {
            if (code != '' && code != ' ' && code != null && types) {
              //gets code from the model collection
              if (types.models) {
                var matchCode = '';
                if(typeof types.models[0].get('code') != 'string'){
                  if(typeof code === 'string'){ //need to know if we are getting from constants
                    var appCode = this.getApplicantType(instType, code);
                  }else{
                    var appCode = code;
                  }
                  return CN.APPLICANT_TYPES()[instType][appCode].description;
                }
                if(typeof code === 'string'){ //if code is string, match it with code from rest service
                _.forEach(types.models, model=>{
                  if (model.get("code") && model.get("code").length > 0 && model.get("description") && model.get("description").length > 0 &&
                    model.get("code").toLowerCase() == code.toLowerCase()) {
                    matchCode =  model.get("description");
                  }
                });
                return matchCode;
              } else {
                _.forEach(types.models, model=>{ //if code is a number, get the string value of it in getApplicantType then match it with code from rest service
                  var codeDesc = this.getApplicantType(instType, code);
                  if (model.get("code") && model.get("code").length > 0 && model.get("description") && model.get("description").length > 0 &&
                    model.get("code") == codeDesc) {
                    matchCode =  model.get("description");
                  }
                });
                return matchCode;
                }
              }
              else {
                for (var i = 0; i < types.length; i++) {
                    //console.log(types[i].code,code);
                    if (types[i].code === code) {
                        //console.log('found '+types[i].description);
                        return types[i].description;
                    }
                }
              }
            }
            return null;
        },
        setDropdownFromListByCode: function(list, id, code) {
            // list must contain code/description pairs
            var option = _.findWhere(list, {
                code: code
            });
            if (option)
                this.setDropdown(id, option.code, option.description);
        },
        setDropdown: function(id, optionValue, optionLabel) {
            $('select[id=' + id + '] option[value="' + optionValue + '"]').prop('selected', true).change();
            $('input[id="' + id + '-shdo"]').val(optionLabel);
        },
        outputErrorMessage: function(errorStr) {
          var str = '<svg class="icon alert" focusable="false" role="presentation"><use xlink:href="#alert"></use></svg><span class="message error"><span class="scr">' + i18n.t('CIVICS.COMMON.ERRORED') + '</span>'+ errorStr +'</span>';

          return str;
        },
        translateTid: function(str){//if str contains tid, use translation files, else return str
            if(str){
                if(str.startsWith('tid:')){
                    var tid = str.substr(4,str.length-1);
                    return i18n.t(tid);
                } else {
                    var translated = str;
                    var pattern = new RegExp('{{tid:(.*)}}');
                    var match = translated.match(pattern);
                    while(match != null){
                        translated = translated.replace(pattern,i18n.t(match));
                        match = translated.match(pattern);
                    }
                    return translated;
                }
            } else {
                return str;
            }
        },
        //ecode the url component
        encodeComponent: function (val) {
          if ( typeof val == "string") {
            val = JSV.escapeString(val);
            return encodeURIComponent(val);
          }
          else {
            return val;
          }
        },
        //default escape double quotes
        attributeEscapeString:function(val)
        {
          return val.replace(/&/g,'&amp;' ).replace(/"/g,'&quot;' ).replace(/</g,'&lt;' ).replace(/>/g,'&gt;' );
        },
        formatAttributeValue: function(type, value)
		{
			let attributeType = type.toLowerCase();

			if(value) {
				if(attributeType == 'boolean' && typeof value != 'boolean')
				{
					value = (value.toLowerCase() == 'true') ? true : false;
				} else if (attributeType == 'timestamp') {
					value = (!value.includes(CN.DATE_DEFAULT_VAL)) ? value : '';
				}
			}

			return value;
		},
        // DEPRECATED - 2026-03-23
        // All references removed from:
        //   - civics-common/views/new_attachments/info_modal/v_itv_attachment_viewer.js
        //   - civics-common/views/new_attachments/upload_modal/v_itv_add_attachment.js
        //   - civics-common/views/attachments/v_itv_add_attachment.js
        //   - civics-common/views/attachments/v_itv_attachment_viewer.js
        // Syphon's registerDefault reader already produces correct ISO datetime strings
        // for date+time fields, making this post-processing unnecessary.
        updateDefaultTime: function(attributeData)
        {
            var timeFields = $('input[data-formattype="time"]');

			//if the timeField is empty default the time value to 12:00 AM
			if(timeFields && timeFields.length > 0)
			{
				$.each(timeFields, (key, val) => {
                    var date = $('input[name=' + '"' + val.name + '"' + ']').val();
					if(val.value == ''){
                        attributeData[val.name] = this.dateTimeString(date, null);
					}
				});
			}

            return attributeData;
        },
        setCookie: function(cname, cvalue, cparam) {
          // Set the cookie name, value, and expiration
          var expireDays = cparam.days,
              expireHours = cparam.hours,
              expireMinutes = cparam.minutes,
              expireSeconds = cparam.seconds;

          let now = new Date();

           if (expireDays) {
               now.setDate(now.getDate() + expireDays);
           }
           if (expireHours) {
               now.setHours(now.getHours() + expireHours);
           }
           if (expireMinutes) {
               now.setMinutes(now.getMinutes() + expireMinutes);
           }
           if (expireSeconds) {
               now.setSeconds(now.getSeconds() + expireSeconds);
           }
          //d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
          //now.setTime(now.getTime() + (minutes * 60 * 1000));
          let expires = "expires="+now.toUTCString();
          document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },
        getCookie: function(cname) {
          // Get the cookie value by name as a string
          let name = cname + "=";
          let ca = document.cookie.split(';');
          for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return "";
        },
        removeCookie: function(cname){
          this.setCookie(cname, "", {seconds: 1});
        },
        // sample input str value  - "{key:value,key:value2}"
        // converted to object of { key:value, key:value }
        // so it can be access using objectName.key
        createObjectFromDirtyJSON(str) {
          let retObj = {};
          if(str && str.length > 0){
            //get all the option using the comma(,) separator
            let splitOptions = str.replace('{','').replace('}','').split(',');
            for(let i = 0; splitOptions.length > i; i++){
              let splitVal = splitOptions[i].split('=');
              if(splitVal.length == 2){
                let key = splitVal[0]; 
                let value = splitVal[1]; 
                retObj[key] = value;
              }
            }
          }
    
          return retObj;
        },
        // droppyInput -  current input
        // newList - new droppy list option
        // partialDropdownOption 
        // value - name of the attribute where the value of droppy will pull
        // text - name of the attribute where the dispaly text of droppy will pull
        // isAddSelectOption - if the empty select option will add
        // isAcceptEmptyNewList - current rebuildDroppyList event of droppy didn't udpate the list if we have empty list. This is use to still update the droppt to empty list
        updateDroppyList: function(droppyInput, newList, partialDropdownOption, value, text, isAddSelectOption, isAcceptEmptyNewList){
          let elementArray = [];
          if(isAddSelectOption){
            let defaultOption = {
              value: '',
              text: i18n.t('CIVICS.COMMON.SELECT')
            };
            elementArray.push(partialDropdownOption($.extend({}, defaultOption)));
          }

          let $droppyList = this.civicsGetDroppyList(droppyInput);
          let selectedValue = this.civicsDropdownValue(droppyInput);
          let codesAray = newList.map(x => x.code);
          codesAray.sort((a, b) => a.localeCompare(b));

          $.each(newList, (index, data) => {
            let isSelected = data[value] === selectedValue;
            let displayText = data[text] ? data[text] : i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG')
      
            let optionData = {
              value: data[value],
              text: displayText,
              selected: isSelected
            };
            elementArray.push(partialDropdownOption($.extend({}, optionData)));
          });
          droppyInput.trigger("rebuildDroppyList", [codesAray, $droppyList, elementArray, selectedValue, isAcceptEmptyNewList]); 
        },
        /**
         * Sanitizes a filename for upload by removing invalid characters
         * Allows: A-Z, a-z, 0-9, underscore, hyphen, space, and period (for extension)
         * Replaces invalid characters with underscore
         * Extension is preserved as-is for validation
         * @param {string} fileName - Original filename to sanitize
         * @returns {string} Sanitized filename safe for upload
         */
        sanitizeFileNameForUpload: function(fileName) {
			if (!fileName) return fileName;
			
			const lastDotIndex = fileName.lastIndexOf('.');
			let name = fileName;
			let extension = '';
			
			if (lastDotIndex > 0) {
				name = fileName.substring(0, lastDotIndex);
				extension = fileName.substring(lastDotIndex);
			}
			
			// Clean filename: allow A-Z, a-z, 0-9, _, -, and spaces
			name = name.replace(/[^A-Za-z0-9_\- ]/g, '_');
			
			return name + extension;
		}
    };
});
